<div class="block-map-container">
  <div class="map-container">
    <div class="map-frame">
      <div id="{{ IdMapPublic }}"></div>
    </div>
  </div>
</div>
